import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getTerms({ commit }, params = {}) {
    return axios.get('/terms/search', { params })
  },
  getTerm({ commit }, params = {}) {
    const id = params.id
    delete params.id
    return axios.get(`/terms/${id}`,  { params })
  },
  createTerm({ commit }, data) {
    return axios.post('/terms', data)
  },
  updateTerm({ commit }, data) {
    return axios.put(`/terms/${data.id}`, data)
  },
  deleteTerm({ commit }, id) {
    return axios.delete(`/terms/${id}`)
  },
  resolveTermOrganisationTypes(){
    return [
      { 
        key: 'DEFAULT',
        value: 'Default (ALL)' 
      }, { 
        key: 'CUSTOMER',
        value: 'Customer'
      }, {
        key: 'SUPPLIER',
        value: 'Supplier'
      }]
  }
}
